import { z } from 'zod';
import { CursorQuery } from '../../common/pagination.js';
import { ContentType } from '../../content.js';
import { Category1, Category2 } from '../../taxonomy.js';
export const FeedScope = z.enum(['for_you', 'following']);
/** Feed / list query — cursor page optionally narrowed by taxonomy (AC-GL-17). */
export const FeedQuery = CursorQuery.extend({
    subcategory: z.literal('travel').optional(),
    communityId: z.string().min(1).optional(),
    scope: FeedScope.optional().default('for_you'),
    category1: Category1.optional(),
    category2: Category2.optional(),
    /**
     * One kind of content: a member's polls, their events, their fundraisers.
     *
     * Both routes that take this query honour it, which is the reason it lives
     * here rather than on the author route alone — a shared query that one of
     * its two routes quietly ignored would advertise a filter that does nothing.
     */
    type: ContentType.optional(),
});
//# sourceMappingURL=schemas.js.map